import React from "react";
import ReactPaginate from "react-paginate";
import { LeftArrowIcon } from "../../icons/LeftArrowIcon";
import { RightArrowIcon } from "../../icons/RightArrowIcon";
import { BreakIcon } from "./BreakIcon";

export function Paginate(props: Props) {

    const { pageCount, onPageChange, currentPage } = props;

    return (
        <ReactPaginate
            pageCount={pageCount}
            onPageChange={selectedItem => onPageChange(selectedItem.selected)}
            forcePage={currentPage}
            marginPagesDisplayed={1}
            pageRangeDisplayed={1}
            containerClassName={"paginate_button"}
            pageClassName={"button"}
            previousLabel={<LeftArrowIcon/>}
            previousClassName={"previous_button"}
            nextLabel={<RightArrowIcon/>}
            nextClassName={"next_button"}
            breakLabel={<BreakIcon/>}
            breakClassName={"break"}
            activeClassName={"active"}
            disabledClassName={"disabled"}
        />
    );
}

type Props = {
    pageCount: number,
    onPageChange: (page: number) => void,
    currentPage: number
}
